import { Box, IconButton, Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

export default function FilterResults({ filterResultsCount }) {
  // hooks
  const router = useRouter();

  return (
    <Box
      sx={{
        bgcolor: theme => theme.palette.background.primaryAccent2,
        color: theme => theme.palette.content.accent1,
        px: '16px',
        py: '7.5px',
        borderRadius: '6px',
        width: 'fit-content',
      }}
    >
      <Stack direction="row" alignItems="center" spacing="8px">
        <Typography variant="h4">
          Filter results {`${filterResultsCount}`}
        </Typography>
        <IconButton
          onClick={() => {
            router.push(paths.dashboard.jobs.root);
          }}
        >
          <Iconify
            sx={{
              color: theme => theme.palette.content.accent1,
            }}
            icon="tabler:x"
          />
        </IconButton>
      </Stack>
    </Box>
  );
}

FilterResults.propTypes = {
  filterResultsCount: PropTypes.number.isRequired,
};
